/**
 *
 * @description  施工模板编辑
 * @author xiongwei_zhang
 *
 * */

import { Dropdown, Menu, message, Modal, Checkbox } from 'antd';
import { useEffect, useState, useRef } from 'react';
import { useEventEmitter } from '&/utils/customHooks/useEventEmitter';
import DetailLeftTree from '@/components/LeftTreeMenu/DetailLeftTree';
import ConstructionTemplateForm from '&/components/TemplateManagement/Modal/ConstructionTemplateForm';
import EditConstructionTemplateModal from '@/components/TemplateSettings/EditConstructionTemplateModal';
import DefaultEmpty from '&/components/TemplateManagement/DefaultEmpty';
import {
    verifyingTemplateContent,
    setDefaultTemplateEditData,
    treeDataTransformTemplateData,
    addPlanStage,
    removePlan,
    regConstruction,
    deleteModal,
    getConstructionData,
    saveTipModal,
} from '&/components/TemplateManagement/common';
import EditGantt from './EditGantt';
import './index.scss';

const EditTaskTemplate = props => {
    const { templateData, visible, setVisible, menuList = [] } = props;
    // templateDetailData 模板的数据，如“系统推介模板”，包含若干施工进度
    const { templateType, title, templateDetailData } = templateData; // 模板父节点如“施工模板”

    const leftTreeMenuRef = useRef();
    const constructionTemplateRef = useRef();
    const editConstructionTemplateModalRef = useRef();
    const [showForm, setShowForm] = useState(false);
    const [selectNodeData, setSelectNodeData] = useState({});
    const [updateType, setUpdateType] = useState(null);
    const [isDisabled, setIsDisabled] = useState(false);
    const { emit } = useEventEmitter();

    useEffect(() => {
        visible && initModal();
    }, [visible]);

    useEffect(() => {
        visible && changeShowForm();
    }, [menuList, visible]);

    const hide = () => {
        setVisible(false);
    };

    const [defaultExpandedKeys, setdefaultExpandedKeys] = useState();

    const initModal = () => {
        if (!templateDetailData) {
            const ID = setTimeout(() => {
                leftTreeMenuRef.current.titleAddHandle();
                clearTimeout(ID);
            });
        } else {
            const treeDetailsData = setDefaultTemplateEditData(
                templateDetailData,
                templateType
            );
            leftTreeMenuRef.current.onSelect(
                [treeDetailsData.id],
                treeDetailsData
            );
            setdefaultExpandedKeys(treeDetailsData.node.key);
        }
    };

    const nodeMenu = nodeData => {
        const deleteDropdown = (
            <Dropdown
                overlay={titleMenu(nodeData)}
                trigger={['click']}
                destroyPopupOnHide
                className="directory-dropdown">
                <i
                    className="icon-more-h filled more"
                    onClick={event =>
                        leftTreeMenuRef.current.handleMore(event)
                    }></i>
            </Dropdown>
        );
        if (nodeData?.originalItem?.type === '1') {
            return '';
        }

        return Array.isArray(nodeData.children) ? (
            <i
                className={`icon-plus outlined${
                    Array.isArray(nodeData.children) ? ' is--parent' : ''
                }`}
                onClick={event => {
                    leftTreeMenuRef.current.handleMore(event);
                    leftTreeMenuRef.current.onAdd(nodeData, true);
                }}></i>
        ) : (
            deleteDropdown
        );
    };

    const titleAdd = () => {
        editConstructionTemplateModalRef.current.show();
    };

    const titleMenu = nodeData => {
        return (
            <Menu>
                <Menu.Item
                    key="2"
                    onClick={e => {
                        deleteModal(
                            () => {
                                removeNode(nodeData);
                            },
                            {
                                content: intl.get(
                                    'templateSettings.templateDeleteWarning'
                                ),
                            }
                        );
                    }}>
                    {intl.get('base.delete')}
                </Menu.Item>
            </Menu>
        );
    };
    const verifyValue = value => {
        if (!regConstruction.test(value)) {
            const msg = intl.get('templateSettings.constructionStageErrorMsg');
            message.warning(msg);
            return false;
        }
        return true;
    };
    const verifySaveValue = (nodeData, treeData) => {
        let list = [];
        const parentData = treeData.filter(
            item => item.id === nodeData.parentId
        )[0];
        list = parentData.children;

        if (
            list
                .filter(item => item.key !== nodeData.key)
                .some(item => item.value === nodeData.value)
        ) {
            const msg = intl.get(
                'templateSettings.constructionStageCanNotRepeatMsg'
            );
            message.warning(msg);
            return false;
        }
        return true;
    };
    const beforeAddNode = option => {
        const { treeData } = option;
        let state = false;
        treeData.forEach(item => {
            if (item.children.some(item => item.is_new === 1)) {
                message.warning(
                    intl.get('templateSettings.haveSaveTemplateMsg')
                );
                state = true;
            }
        });

        return state;
    };
    const updateTreeData = (treeData, newNode) => {
        treeData.forEach(item => {
            if (item.key === newNode?.parentKey) {
                setShowForm(!!item.children?.length);
                setIsDisabled(item.children.some(item => item.is_new === 1));
            }
        });
    };
    const beforeChangeNode = async option => {
        const { keys, treeData } = option;
        let state = false;
        if (keys.length === 0) return state;
        const nowSelectData =
            await constructionTemplateRef.current?.getChangeValue();
        if (!nowSelectData) return true;
        const showCallback = async type => {
            const { keys, data, callback } = option;
            if (type === 'close') {
                callback(keys, data);
            } else {
                const hasError = await saveNode(true);
                if (!hasError) callback(keys, data);
            }
        };
        if (!nowSelectData.templateId) {
            saveTipModal(showCallback);
            state = true;
        } else {
            let originalData =
                treeData.filter(
                    item => item.id === nowSelectData.templateId
                )[0] || {};
            for (let i = 0; i < treeData.length; i++) {
                const item = treeData[i];
                if (item.id === nowSelectData.templateId) {
                    if (
                        item.children.some(
                            sItem => sItem.id === nowSelectData.templateStageId
                        )
                    ) {
                        // eslint-disable-next-line
                        item.children?.forEach(sItem => {
                            if (sItem.id === nowSelectData.templateStageId) {
                                originalData = sItem;
                            }
                        });
                    } else {
                        saveTipModal(showCallback);
                        return true;
                    }
                }
            }
            const isChanged = verifyingTemplateContent({
                templateType,
                oldData: originalData?.originalItem,
                newData: nowSelectData,
            });
            if (isChanged) {
                saveTipModal(showCallback);
                state = true;
            }
        }
        return state;
    };

    const [ganttHighlightProject, setGanttHighlightProject] = useState();
    const [ganttData, setGanttData] = useState();

    const updateGantt = async () => {
        await emit('query-template-list', { templateType });
    };

    // 选择模板后给甘特图赋值
    const assignmentGanttData = (node, templates) => {
        // 点击了模板节点
        const isSelectTempl =
            node.parentKey === 'constructionTemplate' || !node.parentKey;

        const P_KEY = isSelectTempl ? node.key : node.parentKey;
        const findedParent = menuList.find(e => e.key === P_KEY).originalItem;
        setGanttData(findedParent);
        setGanttHighlightProject(isSelectTempl ? null : node.id);
    };

    const afterTreeSelect = async (key, data, templates) => {
        const { node } = data;
        assignmentGanttData(node, templates);

        if (!node?.originalItem?.son?.length && node?.is_new !== 1) {
            setSelectNodeData(node);
            setShowForm(false);
            return;
        } else {
            setSelectNodeData({});
            setShowForm(true);
        }

        if (key.length) {
            const formData = await treeDataTransformTemplateData(
                data,
                templateType,
                key
            );
            setIsDisabled(!formData.constructionStage);
            constructionTemplateRef?.current?.setValue(formData);
        }
    };

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(false);
    }, [templateData]);

    const saveNode = async hasChangeSelect => {
        setLoading(true);
        let hasError = false;
        try {
            const data = await constructionTemplateRef?.current?.getValue();
            if (data) {
                await addPlanStage(data);
                setUpdateType(
                    hasChangeSelect || data.templateStageId ? 'edit' : 'add'
                );
                await emit('query-template-list', {
                    templateType,
                    hideLoading: true,
                    callback(list) {
                        leftTreeMenuRef.current.findAndSelectNode(data, list);
                        setLoading(false);
                    },
                });
            } else {
                hasError = true;
                setLoading(false);
            }
        } catch {
            hasError = true;
            setLoading(false);
        }
        return hasError;
    };
    const removeNode = async nodeData => {
        if (nodeData.is_new !== 1) {
            setUpdateType('delete');
            await removePlan(nodeData);
        }
        await emit('query-template-list', { templateType });
    };

    const getResetTreeKey = (list, type, selectData) => {
        let key = [list[0].key];
        list.forEach(item => {
            if (item.key === selectData.parentKey) {
                key = [item.key];
                if (type === 'add' && item.children.length) {
                    key.push(item.children[item.children.length - 1]?.key);
                } else {
                    if (item.children.length) {
                        key.push(item.children[0].key);
                    }
                }
            }
        });
        return key;
    };

    const changeShowForm = () => {
        let status = false;
        if (menuList?.length) {
            status = templateDetailData?.[0]?.son?.length > 0;
        }
        setShowForm(status);
    };
    const addNode = () => {
        leftTreeMenuRef.current.onAdd(selectNodeData, true);
    };
    const afterAddConstructionTemplate = newData => {
        leftTreeMenuRef.current.setExpandedKeys([]);
        setTimeout(() => {
            const data = newData.children?.[newData.children.length - 1];
            const treeDetailsData = setDefaultTemplateEditData(
                getConstructionData(data),
                templateType
            );
            leftTreeMenuRef.current.onSelect(
                [treeDetailsData.id],
                treeDetailsData
            );
        });
    };

    const optionsWithDisabled = [
        {
            label: '施工模板菜单',
            value: 'visible_menu',
        },
        {
            label: '模板详情',
            value: 'visible_form',
        },
        {
            label: '甘特图详情',
            value: 'visible_gantt',
            disabled: false,
        },
    ];

    const [visibleBlock, setVisibleBlock] = useState(
        optionsWithDisabled.map(item => item.value)
    );

    const [forceResetLayout, setForceResetLayout] = useState(0);
    const onChange = checkedValues => {
        if (!checkedValues.length) return;
        // 甘特图重新布局。防止X轴超出页面
        setForceResetLayout(forceResetLayout + 1);
        setVisibleBlock(checkedValues);
    };

    return (
        <>
            <Modal
                className="edit-task-template"
                closeIcon={<i className="close-btn icon-close1 outlined" />}
                onCancel={hide}
                onOk={saveNode}
                okButtonProps={{
                    disabled: !showForm,
                    loading,
                }}
                cancelText={intl.get('base.cancel')}
                okText={intl.get('base.confirm')}
                centered
                visible={visible}
                width="100vw"
                title={
                    <>
                        <strong className="modal__title">{title}</strong>
                        <Checkbox.Group
                            options={optionsWithDisabled}
                            value={visibleBlock}
                            onChange={onChange}
                        />
                    </>
                }>
                <div
                    className={`template-settings-modal-content ${visibleBlock.join(
                        ' '
                    )}`}>
                    <DetailLeftTree
                        ref={leftTreeMenuRef}
                        treeMenuData={menuList}
                        initComponent={visible}
                        hasInterceptBeforeChangeNode={showForm}
                        getResetTreeKey={getResetTreeKey}
                        updateType={updateType}
                        onTreeSelect={afterTreeSelect}
                        defaultExpandedKeys={defaultExpandedKeys}
                        menuOpt={{
                            nodeMenu,
                            titleAdd,
                            menuTitle: title,
                            showTitleAdd: true,
                            beforeChangeNode,
                            beforeAddNode,
                            updateTreeData,
                            removeNode,
                            inputMaxLength: 15,
                            verifyValue,
                            verifySaveValue,
                        }}
                        multiple={false}
                    />
                    {showForm ? (
                        <>
                            <div className="content-box">
                                <div className="block-title">模板详情</div>
                                <ConstructionTemplateForm
                                    ref={constructionTemplateRef}
                                    disabledForm={isDisabled}
                                />
                            </div>

                            <div className="gantt-wrap-el">
                                <div className="block-title">
                                    甘特图详情
                                    <span className="title-total">
                                        （总工期：{ganttData?.timeLimit}
                                        天）
                                    </span>
                                </div>
                                {ganttData && (
                                    <EditGantt
                                        highlightId={ganttHighlightProject}
                                        forceResetLayout={forceResetLayout}
                                        onChange={updateGantt}
                                        dataSource={ganttData}
                                    />
                                )}
                            </div>
                        </>
                    ) : (
                        <DefaultEmpty
                            option={{
                                title: intl.get(
                                    'templateSettings.emptyTemplate'
                                ),
                                addClick: addNode,
                            }}
                        />
                    )}
                </div>
            </Modal>
            <EditConstructionTemplateModal
                showEditModal={afterAddConstructionTemplate}
                ref={editConstructionTemplateModalRef}
            />
        </>
    );
};

export default EditTaskTemplate;
